import './sass/find-va-forms.scss';
import FindVaForms from './components/FindVaForms';

export default {
  FindVaForms,
};
